import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/Onboarding/Favorites/GET';

export const FAVORITES_GET_SUCCESS = `${rootActionPath}_${SUCCESS_SUFFIX}`;
export const FAVORITES_GET_FAILURE = `${rootActionPath}_${FAILURE_SUFFIX}`;
